// cookie.ts
export type Attribution = {
  utm_source?: string
  utm_medium?: string
  utm_campaign?: string
  utm_term?: string
  utm_content?: string
  referrer?: string
  landing_url?: string
  first_touch?: string
  last_touch?: string
}

/**
 * Reads and parses the attribution cookie ('sn_ref') from the browser.
 *
 * @returns {object | null} The parsed attribution object if present and valid, otherwise null.
 *
 * @example
 * const attribution = readAttributionCookie();
 * if (attribution) {
 *   // Use attribution data
 * }
 */
export function readAttributionCookie(): Attribution | null {
  const COOKIE_NAME = 'sn_ref'
  const raw = document.cookie
    .split('; ')
    .find((r) => r.startsWith(COOKIE_NAME + '='))
    ?.split('=')[1]
  if (!raw) {
    return null
  }
  try {
    return JSON.parse(decodeURIComponent(raw))
  } catch {
    return null
  }
}

export type GTMCookieData = {
  __gtm_campaign_url?: string
  __gtm_referrer?: string
}

/**
 * Reads GTM tracking cookies from the browser.
 *
 * @returns {GTMCookieData} Object containing GTM campaign URL and referrer values
 *
 * @example
 * const gtmData = readGTMCookies();
 * console.log(gtmData.__gtm_campaign_url, gtmData.__gtm_referrer);
 */
export function readGTMCookies(): GTMCookieData {
  console.log('🔄 readGTMCookies: Reading GTM tracking cookies')

  const getCookieValue = (name: string): string | undefined => {
    const value = document.cookie
      .split('; ')
      .find((row) => row.startsWith(name + '='))
      ?.split('=')[1]
    return value ? decodeURIComponent(value) : undefined
  }

  const gtmData: GTMCookieData = {
    __gtm_campaign_url: getCookieValue('__gtm_campaign_url'),
    __gtm_referrer: getCookieValue('__gtm_referrer'),
  }

  console.log('🔄 readGTMCookies: Found GTM data', gtmData)
  return gtmData
}
